import React, { useState } from "react";
import FormGenerator from "./FormGenerator";
import universitiesData from "../../../data/universitiesData";

const ProgramInfoForm = () => {
  const [selectedUni, setSelectedUni] = useState("");  // State for selected university
  const [programs, setPrograms] = useState<{ id: string; name: string; }[]>([]);  // State for programs of the selected university

  const handleUniChange = (uniId:string) => {
    setSelectedUni(uniId);

    // Find the selected university and set its programs
    const selectedUniversity = universitiesData.find(uni => uni.id === uniId);
    if (selectedUniversity) {
      setPrograms(selectedUniversity.courses);
    } else {
      setPrograms([]);
    }
  };

  const handleProgramChange = (programId:string) => {
    // console.log("Selected Program ID:", programId);
  };

  return (
    <div className="h-full w-full flex flex-col justify-center">
      {/* University selection */}
      <FormGenerator
        title="Program Information"
        label="Which university do you plan to attend or attending?"
        type="select"
        onChange={handleUniChange}
        options={universitiesData.map(uni => ({
          value: uni.id,
          label: uni.name
        }))}
      />

      {/* Program selection */}
      <FormGenerator
        label="And what program are you pursuing?"
        type="select"
        onChange={handleProgramChange}
        options={programs.map(program => ({
          value: program.id,
          label: program.name
        }))}
      />
    </div>
  );
};

export default ProgramInfoForm;
